import React from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { Form } from 'reactstrap'
import Text from '../utils/Text'
import components from '../components/quiz'
import ProgressBar from '../components/quiz/ProgressBar'
import Question from '../components/quiz/Question'
import BtnAction from '../components/form/BtnAction'
import ArrowRight from '../components/icons/ArrowRight'
import {
  QuestionContainer,
  BtnContainer,
  Title,
  Icon,
} from './QuizStyles'

export default function QuizPage({ step }) {
  const [{ intro, btnNext, btnFinish }] = useStoreState(state => [
    state.steps.pages[step],
  ])
  const [
    { current, unlocked, questions, stepQuiz },
  ] = useStoreState(state => [state.quiz])
  const [{ nextStep, submit }] = useStoreActions(state => [
    state.quiz,
  ])

  const { title, titleSize, titleColor, marginBTitle } = intro
  const TypeComponent = components[current.type]

  return (
    <Form
      className="quiz-component"
      onSubmit={ev => {
        ev.preventDefault()
        submit()
      }}
    >
      <QuestionContainer>
        <Title
          titleSize={titleSize}
          titleColor={titleColor}
          marginBTitle={marginBTitle}
        >
          <Text id={title} markdown />
        </Title>
        <ProgressBar color="#ffae45" />
        <Question key={current.id} config={current}>
          <TypeComponent
            answers={current.answers}
            rules={current.rules}
            subtitleSize={current.subtitleSize}
          />
        </Question>
      </QuestionContainer>
      <BtnContainer unlocked={unlocked}>
        <Icon>
          <ArrowRight width="24" height="24" />
        </Icon>
        {questions.length !== stepQuiz + 1 ? (
          <BtnAction
            type="button"
            action={ev => {
              ev.preventDefault()
              nextStep()
            }}
            btn={btnNext}
          />
        ) : (
          <BtnAction type="submit" id="submit-quiz" btn={btnFinish} />
        )}
      </BtnContainer>
    </Form>
  )
}
